/*انبار*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="warehouse (1)"
      xmlns="http://www.w3.org/2000/svg"
      width={86.722}
      height={86.72}
      viewBox="0 0 86.722 86.72"
      {...props}
    >
      <g data-name="Group 355">
        <path
          data-name="Path 7596"
          d="M43.36 9.79L8.392 31.807v53.515h69.937V31.807z"
          fill="#c7e2fb"
        />
      </g>
      <path
        data-name="Path 7597"
        d="M43.36 9.79L8.392 31.807v39.5c.467.008.93.031 1.4.031 30.351 0 55.554-19.23 60.6-44.522z"
        fill="#ebf7fe"
      />
      <path
        data-name="Path 7598"
        d="M16.785 43.36h53.152v41.962H16.785z"
        fill="#c1c8d1"
      />
      <path
        data-name="Path 7599"
        d="M55.949 71.334h11.19v8.392h-11.19z"
        fill="#976947"
      />
      <path
        data-name="Path 7600"
        d="M67.139 71.334h11.19v8.392h-11.19z"
        fill="#cda57d"
      />
      <path
        data-name="Path 7601"
        d="M61.544 62.942h11.19v8.392h-11.19z"
        fill="#c18e5c"
      />
      <path
        data-name="Path 7602"
        d="M1.399 27.974L43.361 1.398l41.962 26.576-4.2 5.595L43.361 9.79 5.599 33.569z"
        fill="#88929f"
      />
      <path
        data-name="Path 7603"
        d="M16.785 60.145h11.19v8.392h-11.19z"
        fill="#c18e5c"
      />
      <path
        data-name="Path 7604"
        d="M16.785 68.537h11.19v8.392h-11.19z"
        fill="#cda57d"
      />
      <path
        data-name="Path 7605"
        d="M16.785 76.929h11.19v8.392h-11.19z"
        fill="#c18e5c"
      />
      <path
        data-name="Path 7606"
        d="M27.975 76.929h11.19v8.392h-11.19z"
        fill="#cda57d"
      />
      <path
        data-name="Path 7607"
        d="M39.165 76.929h11.19v8.392h-11.19z"
        fill="#c18e5c"
      />
      <path
        data-name="Path 7608"
        d="M27.975 68.537h11.19v8.392h-11.19z"
        fill="#976947"
      />
      <g data-name="Group 356">
        <path
          data-name="Path 7609"
          d="M0 83.923h86.722v2.8H0z"
          fill="#88929f"
        />
      </g>
      <path
        data-name="Path 7610"
        d="M26.576 29.372h33.57v8.392h-33.57z"
        fill="#c1c8d1"
      />
      <circle
        data-name="Ellipse 357"
        cx={2.841}
        cy={2.841}
        r={2.841}
        transform="translate(58.601 79.554)"
        fill="#a0a8b2"
      />
      <circle
        data-name="Ellipse 358"
        cx={2.841}
        cy={2.841}
        r={2.841}
        transform="translate(72.808 79.554)"
        fill="#a0a8b2"
      />
      <g data-name="Group 357">
        <path
          data-name="Path 7611"
          d="M79.47 83.923a3.929 3.929 0 000-2.8h3.055v-2.8h-2.8v-6.989a1.4 1.4 0 00-1.4-1.4h-4.2v-6.992a1.4 1.4 0 00-1.4-1.4h-1.4V43.359a1.4 1.4 0 00-1.4-1.4h-53.14a1.4 1.4 0 00-1.4 1.4v40.564H9.791V32.579l33.57-21.136L76.93 32.581v34.557h2.8v-32.8l.653.411a1.4 1.4 0 001.865-.345l4.2-5.595a1.4 1.4 0 00-.369-2.02L44.11.217a1.4 1.4 0 00-1.5 0L.652 26.793a1.4 1.4 0 00-.627.929 1.384 1.384 0 00.255 1.091l4.2 5.595a1.4 1.4 0 001.865.345l.653-.411v49.581H0v2.8h86.722v-2.8zM5.94 31.699l-2.514-3.354L43.361 3.054 83.3 28.345l-2.519 3.354L44.106 8.605a1.406 1.406 0 00-1.491 0zm70.99 50.825a1.4 1.4 0 11-1.4-1.4 1.4 1.4 0 011.4 1.4zm-16.785 0a1.4 1.4 0 111.4 1.4 1.4 1.4 0 01-1.399-1.4zm-2.8-9.791h2.8v2.8h2.8v-2.8h2.8v5.595h-8.397zm8.135 8.392h6.111a3.92 3.92 0 000 2.8h-6.109a3.92 3.92 0 000-2.8zm11.447-2.8h-8.389v-5.592h2.8v2.8h2.8v-2.8h2.8zm-13.984-8.39V64.34h2.8v2.8h2.8v-2.8h2.8v5.595zm-1.4-8.392a1.4 1.4 0 00-1.4 1.4v6.994h-2.8v-9.793a1.4 1.4 0 00-1.4-1.4h-5.589v2.8h4.2v18.183a1.4 1.4 0 001.4 1.4h1.656a3.93 3.93 0 000 2.8h-5.857v-6.998a1.4 1.4 0 00-1.4-1.4h-9.79v-6.992a1.4 1.4 0 00-1.4-1.4h-9.79v-6.993a1.4 1.4 0 00-1.4-1.4h-9.789v-2.8h50.354v5.595zM18.184 75.53v-5.595h2.8v2.8h2.8v-2.8h2.8v5.595zm5.595-11.19v-2.8h2.8v5.595h-8.395v-5.592h2.8v2.8zm11.19 8.392v-2.8h2.8v5.595h-8.396v-5.592h2.8v2.8zm-5.595 5.595h2.8v2.8h2.8v-2.8h2.8v5.595h-8.401zm11.19 0h2.8v2.8h2.8v-2.8h2.8v5.595h-8.401zm27.974-25.176H18.184v-2.8h50.354zm0-8.392v2.8H18.184v-2.8zM18.184 78.328h2.8v2.8h2.8v-2.8h2.8v5.595h-8.4z"
        />
        <path
          data-name="Path 7612"
          d="M26.577 27.974a1.4 1.4 0 00-1.4 1.4v8.392a1.4 1.4 0 001.4 1.4h33.57a1.4 1.4 0 001.4-1.4v-8.392a1.4 1.4 0 00-1.4-1.4zm32.17 8.392h-30.77v-5.592h30.77z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
